import { sygnet } from "./sygnet";
import { logo } from "./logo";
import { logoNegative } from "./logo-negative";

import {
  cilArrowThickToTop,
  cilArrowThickToBottom,
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,
  cilUser,
  cilLockLocked,
  cilAccountLogout,
  cilList,
  cilOptions,
  cilPencil,
  cilSettings,
  cilCast,
  cilMediaPlay,
  cilPlus,
  cilTrash,
  cilHamburgerMenu,
  cilMinus,
  cilClock,
  cilX,
  cilSave,
  cilFilter,
} from "@coreui/icons";

export const icons = Object.assign(
  {},
  {
    sygnet,
    logo,
    logoNegative,
  },
  {
    cilArrowThickToTop,
    cilArrowThickToBottom,
    cilApplicationsSettings,
    cilSpeedometer,
    cilSun,
    cilMoon,
    cilUser,
    cilLockLocked,
    cilAccountLogout,
    cilList,
    cilOptions,
    cilPencil,
    cilSettings,
    cilCast,
    cilMediaPlay,
    cilPlus,
    cilTrash,
    cilHamburgerMenu,
    cilMinus,
    cilClock,
    cilX,
    cilSave,
    cilFilter,
  }
);
